<his-table-config
    [selectableColumns]="selectableCols"
    [configuratedColumns]="historyColumns"
    [reorderable]="isReorderable"
    (onSave)="refreshTableColumns($event)">
</his-table-config>
<p-table [columns]="historyColumns" [value]="historyRows" [reorderableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="isReorderable">
            <th *ngFor="let column of columns" pReorderableColumn>
                <button hisImage="ARROW_LEFT" (click)="moveTableColumn(columns, column, -1)" class="icon" name="reorderTable" title="{{'reorder.arrow_left' | hisUi}}"></button> 
                    {{column.title | hisUi}}
                <button hisImage="ARROW_RIGHT" (click)="moveTableColumn(columns, column, 1)" class="icon" name="reorderTable" title="{{'reorder.arrow_right' | hisUi}}"></button> 
            </th>
        </tr>
        <tr *ngIf="!isReorderable">
            <th *ngFor="let column of columns">
                {{column.title | hisUi}}
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let column of columns">
                <span *ngIf="column.field === 'executingDate'; else elseBlock">
                    {{ rowData[column.field] | hisDate }}
                </span>
                <ng-template #elseBlock> {{ rowData[column.field] }}</ng-template>
            </td>
        </tr>
    </ng-template>
</p-table>
